import { Component, OnInit, Output, EventEmitter, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { HttpService } from 'src/app/services/http.service';
import * as enLocale from 'date-fns/locale/en';
import { DatepickerOptions } from 'ng2-datepicker';
import { IMyDrpOptions } from 'mydaterangepicker';
import { configs } from 'src/app/configs/app.config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-editCard',
  templateUrl: './editCard.component.html',
  styleUrls: ['./editCard.component.scss']
})
export class EditCardComponent implements OnInit {


  @HostListener('click', ['$event']) onClick(event: any) {
    if (event.target.classList.contains('popup-bg')) {
      this.globalService.showTrue = true;
      this.forPopupClose();
      document.body ? document.body.classList.remove('no-scroll') : '';
    }
  }

  @ViewChild('cardValue', { static: false }) cardValue: ElementRef;
  @Output() closePopEvent = new EventEmitter();
  @Output() valueChange = new EventEmitter();
  @Input() listData: any;
  @Input() index: any;
  @Input() cardName: any;
  public editCard: FormGroup;
  public errorMessage: string = "";
  public networks: any;
  public location: any;
  public networktag: any;
  public apps:any;
  public streamType: any;
  public dropdownSettings: IDropdownSettings = {};
  public kpiValueListArray: Array<any> = [];
  public deviceCategory: string;
  public successMessage: string = '';
  public warningMessage: string = '';
  public _listData: any;
  public kpiList: Array<any> = [];
 
  public date: Date = new Date();
  public options: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY',

  };
  myDateRangePickerOptions: IMyDrpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };

  // For example initialize to specific date (09.10.2018 - 19.10.2018). It is also possible
  // to set initial date range value using the selDateRange attribute.
  public model: any = {
    // beginDate: { year: 20, month: 4, day: 9 },
    // endDate: { year: 20, month: 4, day: 19 }
  };
  public peers: any;

  constructor(public globalService: GlobalService, private formBuilder: FormBuilder, private httpService: HttpService) {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false,
      showSelectedItemsAtTop: true
    };
    this.editCard = this.formBuilder.group({
      networks: [''],
      networks_select_name: [''],
      networktag: [''],
      networktag_select_name: [''],
      location: [''],
      location_select_name: [''],
      peers: [''],
      peers_select_name: [''],
      deviceCategory: [''],
      deviceCategory_select_name: [''],
      kpiType:[''],
      kpiType_select_name:[],
      // streamType: [''],
      // streamType_select_name: [''],
      locationArray: [],
      deviceCategoryArray: [],
      platformArray: [],
      appVersionArray: [],
      telcoArray: [],
      networkTagArray: [],
      scoreName:[''],
      scoreName_select_name:[''],
      model: [''],
      appNameArray: ['']
    });
  }


  public changeSelection(selectedValue): void {
    setTimeout(() => {
      let option = selectedValue['fieldName'];
      this.editCard.controls[option].setValue(selectedValue['id']);
      if(selectedValue['fieldName']=='kpiType'){
        if(this._listData.raw==selectedValue['id']){
        this.fetchKpiList(this.editCard['controls']['kpiType']['value'],true);
        }else{
        this.fetchKpiList(this.editCard['controls']['kpiType']['value'],false);
        }
        this.editCard.controls[option].setValue(selectedValue['id']);
      }
    }, 0);
  }
  public fetchKpiList(val,bool): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id+'?raw='+val).subscribe((response: any) => {
      if (response) 
        this.kpiList = this.globalService.toObject('', response);
        if(bool){
        this._listData.scoreName = this.storeKpiValue;
        this.editCard.get('scoreName').setValue(this._listData.scoreName)
        }else{
        this._listData.scoreName=this.kpiList[0]['id'];
        this.editCard.get('scoreName').setValue(this._listData.scoreName)
        }
    });

  }
  ngOnInit() {
    if (this.cardName == 'benchmarking' && this.globalService.orderType=='app') {
      this.httpService.createGetRequest(configs['api']['fetchApp'] + this.globalService.order_id).subscribe((response: any) => {
        this.peers = this.globalService.toObject('', response);
      },
        (error) => {
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        });
    }
    if (this.cardName == 'benchmarking' && this.globalService.orderType=='telco') {
      this.httpService.createGetRequest(configs['api']['fetchNetworks'] + this.globalService.order_id).subscribe((response: any) => {
        this.peers = this.globalService.toObject('', response);
      },
        (error) => {
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        });
    }
  }


  forPopupClose() {
    this.closePopEvent.emit();
    document.body ? document.body.classList.remove('no-scroll') : '';
  }

  getMonthValue(value): string {
    let m = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    for (let index = 0; index < m.length; index++) {
      const element = m[index];
      if (element == value)
        return index < 10 ? '0' + index : '' + index;
    }
  }

  fillData(type: string, inputArr: Array<any>) {
    if (this._listData[type] && this._listData[type].length > 0) {
      let arr = [];
      for (let index = 0; index < inputArr.length; index++) {
        const element = inputArr[index];
        if (this._listData[type].indexOf(element['item_text']) > -1) {
          let obj = { 'item_id': element['item_id'], "item_text": element['item_text'] };
          arr.push(obj);
        }
      }
      let obj = {};
      obj[type + 'Array'] = arr;
      this.editCard.patchValue(obj);
    }
  }
public storeKpiValue = '';
  ngDoCheck() {
    if (this.listData && this.listData != this._listData) {
      this._listData = this.listData;
      // if (this._listData && this._listData['scoreName'] && this._listData && this._listData[this._listData['scoreName']] && this._listData[this._listData['scoreName']][0]['subScores']) {
 if(this._listData && this._listData['scoreName'] && this._listData[this._listData['scoreName']] && this._listData[this._listData['scoreName']] && this._listData[this._listData['scoreName']][0]){
        this.kpiValueListArray = this._listData[this._listData['scoreName']][0]['subScores'];
        this.fillData('location', this.globalService.dropdownList);
        this.fillData('telco', this.globalService.multiSelectNetwork);
        this.fillData('networkTag', this.globalService.multiSelectSpeed);
        this.fillData('appVersion', this.globalService.multiSelectAppVersion);
        this.fillData('deviceCategory', this.globalService.multiSelectDeviceCategory);
        this.fillData('appName', this.globalService.multiselectAppsList);
        this.fillData('platform',this.globalService.multiSelectPlatform);
        this.storeKpiValue = this._listData.scoreName;
        this.editCard.patchValue({
          scoreName: this._listData && this._listData.scoreName && this._listData.scoreName ? this._listData.scoreName : '',
          scoreName_select_name: this._listData && this._listData.scoreName && this._listData.scoreName ? this._listData.scoreName : '',
          // streamType_select_name: this._listData && (this._listData.videoStreamType == true) ? 'Live' : 'Vod',
          // streamType: this._listData && (this._listData.videoStreamType == true) ? 'Live' : 'Vod',
          peers_select_name: this._listData && this._listData.peers ? this._listData.peers : '',
          startDate: this._listData && this._listData.startDate ? this._listData.startDate : '',
          endDate: this._listData && this._listData.endDate ? this._listData.endDate : '',
          peers: this._listData && this._listData.peers ? this._listData.peers : '',
          kpiType:this._listData && this._listData.raw ? (this._listData.raw?'Metrics':'Index') : 'Index',
          kpiType_select_name:this._listData && this._listData.raw ? (this._listData.raw?'Metrics':'Index') :'Index',
        });
      }
    }
  }

  public Card_color: string = '#fa000a';

  ngAfterViewInit() {
    let card_value = this.cardValue.nativeElement.innerText;
    if (card_value < 2) {
      this.Card_color = '#fa000a';
    } else if (card_value >= 2 && card_value < 3) {
      this.Card_color = '#ffa500';
    } else {
      this.Card_color = '#04e474';
    }

    this.date = this.listData && this.listData.endDate && this.listData.endDate.replace(/-/g, "/");

    if (this.listData && this.listData.endDate && this.listData.startDate) {
      let arrEndDate = this.listData.endDate.split('-');
      let arrStartdDate = this.listData.startDate.split('-');

      this.model = {
        beginDate: { year: parseInt(arrStartdDate[2]), month: (parseInt(this.getMonthValue(arrStartdDate[1] ? arrStartdDate[1].substr(0, 3) : '')) + 1), day: parseInt(arrStartdDate[0]) },
        endDate: { year: parseInt(arrEndDate[2]), month: (parseInt(this.getMonthValue(arrEndDate[1] ? arrEndDate[1].substr(0, 3) : '')) + 1), day: parseInt(arrEndDate[0]) }
      };
      this.editCard.patchValue({
        model: {
          beginDate: { year: parseInt(arrStartdDate[2]), month: (parseInt(this.getMonthValue(arrStartdDate[1] ? arrStartdDate[1].substr(0, 3) : '')) + 1), day: parseInt(arrStartdDate[0]) },
          endDate: { year: parseInt(arrEndDate[2]), month: (parseInt(this.getMonthValue(arrEndDate[1] ? arrEndDate[1].substr(0, 3) : '')) + 1), day: parseInt(arrEndDate[0]) }
        }
      })
    } else {
      this.model = {
        // beginDate: { year: '', month: '', day: '' },
        // endDate: { year: '', month: '', day: '' }
      };
    }
  }

  cleanBeforeSendParams(obj) {
    var arr = [];
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "--" || obj[propName] === "aN--NaN" || obj[propName] === "NaN--NaN" || obj[propName].length === 0 || obj[propName] === " " || obj[propName] === "select" || obj[propName] === "Select" || (obj[propName] && obj[propName][0] === "select")) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onSubmit() {
    this.errorMessage = "";
    this.warningMessage = "";
    this.successMessage = "";
    let obj = {
      "type": this.globalService.orderType,
      "scoreName": this.editCard['controls']['scoreName']['value'] ? this.editCard['controls']['scoreName']['value'] : "",
      "mainApp": this.globalService.selectedOrder['mainApp'],
      "telco": this.editCard['controls']['telcoArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['telcoArray']['value']) : [],
      "appName": this.editCard['controls']['appNameArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['appNameArray']['value']) : [],
      "speed": this.editCard['controls']['networkTagArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['networkTagArray']['value']) : [],
      "location": this.editCard['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['locationArray']['value']) : [],
      // "videoStreamType": this.editCard['controls']['streamType']['value'] === 'Live' ? true : false,
      "appVersion": this.editCard['controls']['appVersionArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['appVersionArray']['value']) : [],
      "cardId": this.listData._id,
      "deviceCategory": this.editCard['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['deviceCategoryArray']['value']) : "",
      "startDate": this.editCard['controls']['model']['value'] ? this.changeDateFormat(this.editCard['controls']['model']['value']['beginDate']) : '',
      "endDate": this.editCard['controls']['model']['value'] ? this.changeDateFormat(this.editCard['controls']['model']['value']['endDate']) : '',
      "peers": this.editCard['controls']['peers']['value'] ? this.editCard['controls']['peers']['value'] : "",
      "platform": this.editCard['controls']['platformArray']['value'] ? this.globalService.getDataAsString(this.editCard['controls']['platformArray']['value']) : "",
      "raw":this.editCard['controls']['kpiType']?((this.editCard['controls']['kpiType']['value']=='Index'|| this.editCard['controls']['kpiType']['value']==false)?false:true):false,
      cardType: this.cardName
    };
    this.httpService.createPutRequest(configs['api']['updatecard'], this.cleanBeforeSendParams(obj), this.globalService.order_id).subscribe((response: any) => {
      document.body ? document.body.classList.remove('no-scroll') : '';
      this.globalService.scrollToTop();
      this.successMessage = 'Card Updated successfully.';
      setTimeout(() => {
        this.forPopupClose();
        this.successMessage = "";
        // this.globalService.showTrue = true;
        // this.globalService.showPopUp = "";
      }, 4000);
      this.globalService.updateCardSourceMethod({ type: this.cardName, data: response });
    },
      (error) => {
        this.errorMessage = (error.error['statusCode'] && error.error['statusCode'] === 404) ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 6000);
        this.globalService.scrollToTop();
      });
  }
  changeDateFormat(object) {
    return (('' + object['day']).length == 1 ? '0' + object['day'] : object['day']) + '-' + (('' + object['month']).length == 1 ? this.globalService.monthchange(+('0' + object['month'])) : this.globalService.monthchange(+object['month'])) + '-' + object['year'];
  }

  deleteCard() {
    this.httpService.createDeleteRequest(configs['api']['deletecard'], '', this.listData._id, this.globalService.order_id).subscribe((response: any) => {
      this.valueChange.emit(true);
      this.globalService.scrollToTop();
      this.successMessage = 'success';
      document.body ? document.body.classList.remove('no-scroll') : '';
      setTimeout(() => {
        this.forPopupClose();
      }, 3000);
    },
      (error) => {
        this.errorMessage = (error.error['statusCode'] && error.error['statusCode'] === 404) ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 6000);
        this.globalService.scrollToTop();
      })
  }
}